var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherEfficiency(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7066_35177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2966 1.64783C8.58617 1.80341 6.04442 2.85664 4.01562 4.66475L7.15325 7.80237C8.33403 6.81936 9.76775 6.22531 11.2966 6.08562V1.64783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15834 8.79639L3.02077 5.65881C1.21111 7.68705 0.156562 10.229 0 12.94H4.43798C4.57861 11.4109 5.17392 9.97708 6.15834 8.79639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5641 12.94H24.0021C23.8455 10.229 22.791 7.68705 20.9813 5.65881L17.8438 8.79639C18.8282 9.97703 19.4235 11.4109 19.5641 12.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 14.3463C19.4639 15.4293 19.1549 16.3325 18.7893 17.0571C19.1459 17.607 19.4432 18.0717 19.6396 18.3803C20.1744 19.2209 20.056 20.2999 19.3516 21.0043C19.1805 21.1754 18.9852 21.3132 18.7734 21.4151L19.5042 22.1458C19.6417 22.2834 19.822 22.3521 20.0022 22.3521C20.1825 22.3521 20.3627 22.2834 20.5002 22.1458C22.606 20.0403 23.8339 17.2927 24.002 14.3463H19.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43953 14.3463H0C0.168047 17.2927 1.39594 20.0403 3.5017 22.1459C3.63923 22.2834 3.81947 22.3522 3.9997 22.3522C4.17994 22.3522 4.36022 22.2834 4.49775 22.1459L6.63113 20.0124C6.90614 19.7373 6.90614 19.2913 6.63113 19.0163C6.07439 18.4595 4.67203 16.9009 4.43953 14.3463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9841 4.66475C17.9553 2.85659 15.4135 1.80341 12.7031 1.64783V6.08562C14.2319 6.22531 15.6657 6.81936 16.8465 7.80237L19.9841 4.66475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5596 12.0927C12.6982 11.2313 11.2966 11.2313 10.4351 12.0927C9.57371 12.9541 9.57371 14.3558 10.4351 15.2172C11.5234 16.3055 16.8716 19.7203 17.4779 20.1061C17.7559 20.283 18.1195 20.2431 18.3526 20.0101C18.5856 19.7771 18.6255 19.4135 18.4486 19.1354C18.0627 18.5292 14.6479 13.1809 13.5596 12.0927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7066_35177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherEfficiency);
export default __webpack_public_path__ + "static/media/teacher-efficiency.e31a7878da1305be5f473b39c213b7e0.svg";
export { ForwardRef as ReactComponent };